"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _translateTitle = _interopRequireDefault(require("../mixins/translate-title"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = {
  name: 'iMenuSideTitle',
  mixins: [_translateTitle.default],
  props: {
    menu: {
      type: Object,
      default() {
        return {};
      }
    },
    hideTitle: {
      type: Boolean,
      default: false
    },
    // 用于侧边栏收起 Dropdown 当前高亮
    selected: {
      type: Boolean,
      default: false
    },
    // 侧边栏折叠状态
    collapse: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    withIcon() {
      return this.menu.icon || this.menu.custom || this.menu.img;
    }
  }
};
exports.default = _default;